query RefundsList($page: Int, $rowsPerPage: Int, $filter: JSON) {
  refunds(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      organizationId
      amount {
        value
        currency
        valueUSD
      }
      ottkitFeeAmount {
        valueUSD
      }
      organizationAmount {
        valueUSD
      }
      status
      manual
      initiatedBy
      description
      createdAt
      organization {
        title
      }
      payment {
        userId
        buyerEmail
        provider
        product {
          title
          type
        }
      }
    }
  }
}
